module.exports = __webpack_public_path__ + "static/media/cert_84.5ec88046.jpg";